export default function headerScroll() {
    return {
      lastScrollY: window.scrollY,
      ticking: false,
  
      init() {
        window.addEventListener('scroll', () => {
          if (!this.ticking) {
            requestAnimationFrame(() => {
              this.handleScroll();
              this.ticking = false;
            });
            this.ticking = true;
          }
        });
      },
  
      handleScroll() {
        const scrollY = window.scrollY;
        const scrollingUp = scrollY < this.lastScrollY;
        const pastThreshold = scrollY >= 120;
  
        if (pastThreshold) {
          document.body.classList.toggle('scrolling-up', scrollingUp);
          document.body.classList.toggle('scrolling-down', !scrollingUp);
        } else {
          document.body.classList.remove('scrolling-up', 'scrolling-down');
        }
  
        this.lastScrollY = scrollY;
      }
    };
  }